export default "__VITE_ASSET__CrngQcHJ__"